import { DialogProps, Dialog as DialogRoot } from '@material-ui/core';
import React, { FC } from 'react';
import { DialogType } from 'src/redux/types/redux.types';

import DialogHeader from './DialogHeader';

import { makeStyles } from '@material-ui/core/styles';
import { appendPropsToChildren } from 'utils/functions/d.utils';

type AppDialogProps = DialogProps & {
  header?: React.ReactNode;
  children: React.ReactNode;
  type: DialogType;
  onClose?: React.MouseEventHandler<HTMLAnchorElement>;
  hideX?: Boolean;
};

const useStyles = makeStyles({
  modalContainer: {
    '& .MuiDialog-paperScrollPaper': {
      marginBottom: 35,
      maxHeight: 'calc(100vh - 48px)',
      borderRadius: '18px',
    },
  },
});

const Dialog: FC<AppDialogProps> = ({ hideX, open, header, children, onClose, type, ...props }) => {
  const childrenWithProps = appendPropsToChildren(children, {
    dialogProps: { onClose, header },
    ...props,
  });
  const classes = useStyles();

  return (
    <DialogRoot open={open} maxWidth="lg" className={classes.modalContainer} {...props}>
      <DialogHeader onClose={onClose} type={type} hideX={hideX}>
        {header}
      </DialogHeader>
      {childrenWithProps}
    </DialogRoot>
  );
};

Dialog.defaultProps = {
  header: null,
};

export default Dialog;
